function Slideshow(element) {
    this.$element = $(element);

    this.selectors = {
	    container: '.js-slideshow-container',
	    pager: '.js-slideshow-pager',
	    buttonNext: '.js-slideshow-next',
	    buttonPrev: '.js-slideshow-prev',
	    buttonPlay: '.js-slideshow-play',
	    buttonPause: '.js-slideshow-pause'
    };
    
    this.modifiers = {
	    navigationHidden: 'c-slideshow--navigation-hidden'
    };
    
    this.data = {
	    hideNavigation: 'hide-navigation',
	    sliderEffect: 'slider-effect',
	    sliderLoop: 'slider-loop',
	    sliderTimeout: 'slider-timeout',
	    sliderSpeed: 'slider-speed',
	    sliderPager: 'slider-pager',
	    sliderAutostart: 'slider-autostart',
	    autoInit: 'auto-init'
    };
    
    this.triggers = {
	    destroy: 'i4-slideshow:destroy',
	    init: 'i4-slideshow:initSlider'
    };
    
    this.init = function() {
	    this.$container = this.$element.find(this.selectors.container);
	    this.$buttonPlay = this.$element.find(this.selectors.buttonPlay);
	    this.$buttonPause = this.$element.find(this.selectors.buttonPause);
	    this.$buttonPrev = this.$element.find(this.selectors.buttonPrev);
	    this.$buttonNext = this.$element.find(this.selectors.buttonNext);
	    
	    this.option = {
		    hideNavigation: this.$element.data(this.data.hideNavigation) === 1,
		    effect: this.$element.data(this.data.sliderEffect),
		    loop: this.$element.data(this.data.sliderLoop) === 1,
		    timeout: this.$element.data(this.data.sliderTimeout),
		    speed: this.$element.data(this.data.sliderSpeed),
		    pager: this.$element.data(this.data.sliderPager) === 1,
		    autostart: this.$element.data(this.data.sliderAutostart) === 1
	    };

	    this.$buttonPrev.on('click', this.$onPrevClick.bind(this));
	    this.$buttonNext.on('click', this.$onNextClick.bind(this));
	    
	    this.$buttonPlay.on('click', this.$onPlayClick.bind(this));
	    this.$buttonPause.on('click', this.$onPauseClick.bind(this));
	    
	    this.$element.on(this.triggers.destroy, this.destroy.bind(this));
	    this.$element.on(this.triggers.init, this.initSlider.bind(this));
	    
	    if (this.option.hideNavigation) {
		    this.$element.addClass(this.modifiers.navigationHidden);
			this.$element.on('mouseover', this.$onMouseover.bind(this));
			this.$element.on('mouseout', this.$onMouseout.bind(this));
	    }

	    this.$container.on('init', (function() {
		    this.sliderInitialized = true;
	    }).bind(this));
	    	    
	    if (this.$element.data(this.data.autoInit) === undefined || this.$element.data(this.data.autoInit) === true) {
			this.initSlider();
	    }
    };
    
    this.play = function() {
		this.$buttonPause.show();
		this.$buttonPlay.hide();
		this.$container.slick('slickPlay');
    };
    
    this.pause = function() {
		this.$buttonPlay.show();
		this.$buttonPause.hide();
		this.$container.slick('slickPause');
    };

    this.destroy = function() {
	    if (this.sliderInitialized) {
	    	this.$container.slick('unslick');
			this.sliderInitialized = false;
	    }
    };

    this.initSlider = function() {
    	// todo - check why this might be called by pages, that do not have the .slick object defined or attached yet - may be it is just a timing issue?
    	if (!this.$container.slick) {
    		return;
		}

	    this.$container.slick({
		    autoplay: false,
		    autoplaySpeed: this.option.timeout*1000,
		    speed: this.option.speed*1000,
		    pauseOnHover: false,
		    dots: this.option.pager,
		    fade: this.option.effect === 'fade',
		    arrows: false,
		    appendDots: this.$element.find(this.selectors.pager),
		    infinite: this.option.loop
	    });
	    
	    if (!this.option.loop) {
		    this.$container.on('beforeChange', (function(event, slick, currentSlide, nextSlide) {
			    if (slick.slideCount === nextSlide + 1) {
				    this.$buttonNext.hide();
			    } else {
				    this.$buttonNext.show();
			    }
			    
			    if (nextSlide === 0) {
				    this.$buttonPrev.hide();
			    } else {
				    this.$buttonPrev.show();
			    }
		    }).bind(this));
	    }
	    
	    if (this.option.autostart) {
		    this.play();
	    } else {
		    this.pause();
	    }
    };
    
    this.$onPrevClick = function(event) {
	    event.preventDefault();
	    
	    this.$container.slick('slickPrev');
    };
    
    this.$onNextClick = function() {
		event.preventDefault();
		
		this.$container.slick('slickNext');
    };
    
    this.$onPlayClick = function() {
		event.preventDefault();
		
		this.play();
		this.$container.slick('slickNext');
	};
    
    this.$onPauseClick = function() {
		event.preventDefault();
		
		this.pause();  
	};
	
	this.$onMouseover = function(event) {
		this.$element.removeClass(this.modifiers.navigationHidden);
	};
	
	this.$onMouseout = function(event) {
		this.$element.addClass(this.modifiers.navigationHidden);
	};
}
